var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.807,
    height: 25,
    viewBox: "0 0 19.807 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    "data-name": "Path 4339",
    d: "M13.972.193A.6.6,0,0,0,13.537,0H3.785A3.3,3.3,0,0,0,.5,3.279V21.721A3.3,3.3,0,0,0,3.785,25H17.022a3.3,3.3,0,0,0,3.285-3.279V7.077a.65.65,0,0,0-.175-.423Zm.175,1.938,4.124,4.33H15.591a1.438,1.438,0,0,1-1.443-1.437Zm2.874,21.661H3.785a2.092,2.092,0,0,1-2.077-2.071V3.279A2.092,2.092,0,0,1,3.785,1.208H12.94V5.024a2.642,2.642,0,0,0,2.651,2.645H19.1V21.721A2.088,2.088,0,0,1,17.022,23.792Zm0,0",
    transform: "translate(0 0)",
    fill: "#2C5DFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    "data-name": "Path 4340",
    d: "M99.715,401.934h-9.94a.6.6,0,1,0,0,1.208h9.946a.6.6,0,1,0-.006-1.208Zm0,0",
    transform: "translate(-84.342 -382.308)",
    fill: "#2C5DFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    d: "M119.437,175.11l2.488-2.675v6.594a.6.6,0,1,0,1.208,0v-6.594l2.488,2.675a.6.6,0,0,0,.882-.821l-3.539-3.8a.6.6,0,0,0-.882,0l-3.539,3.8a.6.6,0,0,0,.03.851A.616.616,0,0,0,119.437,175.11Zm0,0",
    transform: "translate(-112.126 -161.982)",
    fill: "#2C5DFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.c846d437842a6851a336196e01d86295.svg";
export { ForwardRef as ReactComponent };